<template>
  <b-nav-item-dropdown right no-caret @show="closeOpenPanels">
    <template slot="button-content">
      <span v-b-tooltip.hover.bottom :title="userTip" class="user-entry-inner">
        <i class="fas fa-user user-icon" data-test="userButton"></i>
        <span class="user-label">{{ authUsername }}</span>
      </span>
      <i class="fas fa-chevron-down small user-caret"></i>
    </template>
    <b-nav-item
      v-if="hasChangePasswordPermission"
      class="menu-item"
      data-test="changePassword"
      @click.prevent="resetPassword()"
    >
      {{ $t('navbar.resetPassword') }}
    </b-nav-item>
    <b-nav-item class="menu-item" data-test="logout" @click.prevent="doLogout()">
      {{ $t('navbar.logout') }}
    </b-nav-item>
  </b-nav-item-dropdown>
</template>

<script>
import { doLogout, resetPassword } from '../../../plugins/authentication'

// Same breakpoint convention as MainNavBar: below it the username text hides and its tooltip turns
// on. Slightly narrower than the main-nav breakpoint since the right-hand nav has less pressure.
const USERNAME_COLLAPSE_QUERY = '(max-width: 800px)'

export default {
  name: 'UserBar',
  data() {
    return {
      usernameCollapsed: false,
      _userMql: null,
    }
  },
  computed: {
    hasChangePasswordPermission: {
      get() {
        return this.$store.getters.can_ChangePassword || false
      },
    },
    // Tooltip only once the username text is hidden (empty title => bootstrap-vue shows nothing).
    userTip() {
      return this.usernameCollapsed ? this.authUsername : ''
    },
  },
  mounted() {
    this._userMql = window.matchMedia(USERNAME_COLLAPSE_QUERY)
    this.usernameCollapsed = this._userMql.matches
    this._onUserMqlChange = (e) => {
      this.usernameCollapsed = e.matches
    }
    if (this._userMql.addEventListener) {
      this._userMql.addEventListener('change', this._onUserMqlChange)
    } else if (this._userMql.addListener) {
      this._userMql.addListener(this._onUserMqlChange)
    }
  },
  beforeDestroy() {
    if (!this._userMql) return
    if (this._userMql.removeEventListener) {
      this._userMql.removeEventListener('change', this._onUserMqlChange)
    } else if (this._userMql.removeListener) {
      this._userMql.removeListener(this._onUserMqlChange)
    }
  },
  methods: {
    doLogout,
    resetPassword,
    closeOpenPanels() {
      this.$emit('on-close-open-panels')
    },
  },
}
</script>

<style lang="scss" scoped>
.user-entry-inner {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.user-caret {
  margin-left: 0.35rem;
}

@media (max-width: 800px) {
  .user-label {
    display: none;
  }
  .user-caret {
    display: none;
  }
}

.menu-item a {
  color: black;
  padding: 10px 20px !important;
  font-size: 0.8rem;
}

.menu-item,
.menu-item a {
  margin-right: 0 !important;
}

.menu-item a:hover {
  color: black !important;
  background-color: #f8f9fa;
}

/deep/.b-d-item {
  margin-right: 0 !important;
}

/deep/.b-d-item a {
  padding: 10px 20px;
  color: black !important;
  font-size: 0.8rem;
}

/deep/.b-d-item a:hover {
  color: black !important;
}

/deep/.b-d-item a:active {
  background-color: #f8f9fa;
}
</style>
